import { RequestSubscriptionBirth } from 'subscription/models/request-subscription-birth';
import { SubscriptionBirthNonResidentFormVM } from 'shell/components/shared/research-notifications/reasearch-birth-non-resident/subscription-birth-non-resident';
import {
  transformerPaternita,
  transformGeneralita1001,
  transformMaternita,
} from './common-request-transformer';
import { Citizenship } from 'shell/models/person/citizenship';
import { Generality } from 'shell/models/person/generality';
import { SubjectAttributes } from 'shell/models/person/subject-attributes';
import { transformerAttoNascitaFamily } from './birthday-document.transformer';

export const transformerRequestSubscriptionNonResident = (
  values?: SubscriptionBirthNonResidentFormVM,
  isWithoutChoiceDate?: boolean
): RequestSubscriptionBirth => {
  const attoNascita = transformerAttoNascitaFamily(values?.birthdayDocument);

  const hasCitizenship =
    !!values?.citizenship?.state || !!values?.citizenship?.note || !!values?.citizenship?.validity;

  const cittadinanza: Citizenship | undefined = hasCitizenship
    ? {
        codiceStato: values.citizenship?.state?.id || undefined,
        dataValidita: values.citizenship?.validity
          ? values.citizenship?.validity?.toFormat('yyyy-MM-dd')
          : undefined,
        descrizioneStato: values.citizenship?.state?.value || undefined,
        noteStato: values.citizenship?.note || undefined,
      }
    : undefined;

  const generalita1001: { attributiSoggetto?: SubjectAttributes; generalita: Generality } =
    transformGeneralita1001(values?.generality, undefined, undefined, isWithoutChoiceDate);

  const paternita = transformerPaternita(values?.fatherhood || undefined);

  const maternita = transformMaternita(values?.motherhood || undefined);

  return {
    attoNascitaANPR: attoNascita || undefined,
    cittadinanza,
    generalita1001,
    paternita,
    maternita,
    natoMorto: values?.generality?.deathPerson || undefined,
  };
};
